import { type HTMLAttributes } from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

// Tinted glass chips. Tone names match the original kit; "primary" maps onto the
// lime signature.
const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-xs font-medium",
  {
    variants: {
      tone: {
        slate: "border-white/10 bg-white/5 text-foreground/75",
        primary: "border-primary/30 bg-primary/15 text-primary",
        amber: "border-amber-500/30 bg-amber-500/15 text-amber-300",
        orange: "border-orange-500/30 bg-orange-500/15 text-orange-300",
        emerald: "border-emerald-500/30 bg-emerald-500/15 text-emerald-300",
        rose: "border-destructive/40 bg-destructive/15 text-destructive-soft",
        sky: "border-sky-500/30 bg-sky-500/15 text-sky-300",
      },
    },
    defaultVariants: { tone: "slate" },
  },
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...rest }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...rest} />;
}

export { badgeVariants };
